import type { Calendar, CalendarUpdateQuery } from "../Models/Domain";

import { updateCalendar } from "@/Services/TherapyApi/Calendars";
import { isApiError } from "@/Services/Api/Typeguards/isApiError";
import CalendarTransformer from "@/Modules/Transformers/Calendars/Calendar";

import useCalendarsStore from "../Store";

import { hasValue } from "@/Utils/Objects";
import { snake } from "@/Utils/Snakelize";

const updateCalendarActionHandler = async (
  uuid: string,
  query: CalendarUpdateQuery
): Promise<Calendar | undefined> => {
  const calendarStore = useCalendarsStore();

  const resp = await updateCalendar(uuid, snake(query));

  if (hasValue(resp) && !isApiError(resp)) {
    const calendar = CalendarTransformer.toDomain(resp);

    calendarStore.calendars = calendarStore.calendars.map((c) => {
      if (c.uuid === resp.uuid) {
        return calendar;
      }

      return c;
    });

    return calendar;
  }

  return undefined;
};

export default updateCalendarActionHandler;
